import jsPDF from "jspdf";
import { ensureArabicFont, pdfText, hasArabic } from "@/lib/pdfFonts";
import { pdfStr, isRTL } from "@/lib/pdfStrings";

// Driver proof-of-delivery / pickup receipt (A5-ish on A4, DHL-style header)
export async function printStopReceipt({ stop, route, driver, lang = "es" }) {
  const S = pdfStr(lang);
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const dyn = [stop.contacto, stop.direccion, stop.provincia, stop.nota, driver?.nombre];
  if (isRTL(lang) || dyn.some(hasArabic)) await ensureArabicFont(doc);

  // Header band
  doc.setFillColor(11, 15, 25);
  doc.rect(0, 0, W, 72, "F");
  doc.setFont("helvetica", "bold"); doc.setFontSize(20); doc.setTextColor(255, 255, 255);
  doc.text("MEOS CARGO", 40, 45);
  doc.setFontSize(9); doc.setTextColor(203, 213, 225);
  const title = (stop.tipo === "recogida" ? S.pickup : S.delivery) + " · " + S.receipt_title;
  pdfText(doc, title.toUpperCase(), W - 40, 45, { align: "right" });

  // Service band
  doc.setFillColor(185, 28, 28);
  doc.rect(0, 72, W, 22, "F");
  doc.setTextColor(255, 255, 255); doc.setFontSize(9); doc.setFont("helvetica", "bold");
  doc.text(String(stop.tracking_code || "—"), 40, 87);
  doc.text(new Date(stop.at || Date.now()).toLocaleString(), W - 40, 87, { align: "right" });

  let y = 130;
  doc.setTextColor(15, 23, 42); doc.setFont("helvetica", "bold"); doc.setFontSize(11);
  pdfText(doc, S.receiver.toUpperCase(), 40, y); y += 16;
  doc.setFont("helvetica", "normal"); doc.setFontSize(10); doc.setTextColor(51, 65, 85);
  pdfText(doc, stop.contacto || "—", 40, y); y += 13;
  if (stop.direccion) {
    doc.splitTextToSize(`${S.address}: ${stop.direccion} ${stop.provincia || ""}`, W - 80)
      .forEach((l) => { pdfText(doc, l, 40, y); y += 12; });
  }
  if (stop.telefono) { pdfText(doc, `${S.phone || "Tel"}: ${stop.telefono}`, 40, y); y += 12; }

  y += 12;
  doc.setDrawColor(226, 232, 240); doc.line(40, y, W - 40, y); y += 22;
  doc.setFont("helvetica", "bold"); doc.setFontSize(11); doc.setTextColor(15, 23, 42);
  pdfText(doc, S.driver ? S.driver.toUpperCase() : "DRIVER", 40, y); y += 16;
  doc.setFont("helvetica", "normal"); doc.setFontSize(10); doc.setTextColor(51, 65, 85);
  pdfText(doc, `${driver?.nombre || "—"} · ${route?.vehiculo?.matricula || "—"}`, 40, y); y += 13;
  pdfText(doc, `${S.date || "Fecha"}: ${route?.fecha || ""}`, 40, y); y += 13;
  pdfText(doc, `${S.status || "Estado"}: ${stop.estado || ""}`, 40, y); y += 20;

  if (stop.nota) {
    doc.setFont("helvetica", "bold"); doc.setFontSize(9); doc.setTextColor(185, 28, 28);
    pdfText(doc, S.notes.toUpperCase(), 40, y); y += 13;
    doc.setFont("helvetica", "normal"); doc.setTextColor(30, 41, 59);
    doc.splitTextToSize(stop.nota, W - 80).forEach((l) => { pdfText(doc, l, 40, y); y += 12; });
    y += 8;
  }

  doc.setDrawColor(0); doc.line(40, y, W - 40, y); y += 22;
  doc.setFont("helvetica", "bold"); doc.setFontSize(10); doc.setTextColor(15, 23, 42);
  pdfText(doc, S.signature.toUpperCase(), 40, y); y += 8;
  if (stop.firma_data) {
    try { doc.addImage(stop.firma_data, "PNG", 40, y, 200, 80); } catch (e) { console.warn("signature embed", e); }
  } else {
    doc.setDrawColor(180); doc.line(40, y + 60, 240, y + 60);
  }

  doc.setFontSize(7); doc.setTextColor(148, 163, 184);
  doc.text(`Meos Cargo · ${stop.tracking_code || ""} · ${new Date().toLocaleString()}`, W / 2, 800, { align: "center" });
  doc.save(`${stop.tracking_code || "receipt"}.pdf`);
}
